import {BibMotivoBaixaModel} from '@/models/biblioteca/bibmotivobaixa/bibmotivobaixa.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class BibMotivoBaixaService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<BibMotivoBaixaModel>>> {
  return api.post <DataSource <BibMotivoBaixaModel>>('/BibMotivoBaixa/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(bibMotivoBaixa: BibMotivoBaixaModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/BibMotivoBaixa', bibMotivoBaixa);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/BibMotivoBaixa/' + id);
 }

 atualizar(bibMotivoBaixa: BibMotivoBaixaModel): Promise<AxiosResponse> {
  return api.put('/BibMotivoBaixa', bibMotivoBaixa);
 }

 async get(id: number): Promise<BibMotivoBaixaModel> {
  const result = await api.get<BibMotivoBaixaModel>(`/BibMotivoBaixa/${id.toString()}`);
  return result.data;
 }
 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/BibMotivoBaixa/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }

}
export default new BibMotivoBaixaService();
